<template>
    <wrap ref="wrap" :title="title">
        <c-table class="table-w" :amount="true" :head="head" :body="body">

            <template slot="action" slot-scope="{data}">
                <a href="javascript:;" @click="goMore(data)">查看</a>
            </template>

            <template slot="amount_type">
                <span>星期一</span>
            </template>
        </c-table>
    </wrap>
</template>

<script>
  import CTable from './table';
  import mixin from './mixin';
  import Wrap from "./wrap";
  export default {
    name: "QC35",
    mixins: [mixin],
    components: {
      CTable,
      Wrap
    },
    methods: {
      goMore(item) {
        this.$MessageBox.show('d36', {
          title: '结算报表',
          data: {
            head: [

            ],
            body: [
              {
                type: '广东快乐十分',
                count: 0,
                money: 0,
                back: 0,
                res: 0,
                actual_res: 0
              },
              {
                type: '北京赛车PK10',
                count: 10,
                money: 1000,
                back: 1981,
                res: 1981,
                actual_res: 1981
              },
              {
                type: '重庆时时彩',
                count: 0,
                money: 0,
                back: 0,
                res: 0,
                actual_res: 0
              }
            ],
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dialog/QC35.vue